import * as Types from '../../__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MeVariables = Types.Exact<{ [key: string]: never; }>;


export type Me = { __typename?: 'Query', me?: { __typename?: 'USERS', id: string, name?: any | null, email?: any | null, phone?: string | null, username: any, pan_gst?: string | null, usertype?: Types.UserType | null, permissions?: Array<string> | null, status?: string | null, createdAt?: any | null, updatedAt?: any | null, application?: boolean | null, progressReport?: boolean | null, region?: { __typename?: 'Region', state?: any | null, district?: any | null, village?: any | null, block?: any | null, grampanchayat?: any | null, address?: string | null, geolocation?: any | null } | null } | null };


export const MeDocument = gql`
    query Me {
  me {
    id
    name
    email
    phone
    username
    pan_gst
    region {
      state
      district
      village
      block
      grampanchayat
      address
      geolocation
    }
    usertype
    permissions
    status
    createdAt
    updatedAt
    application
    progressReport
  }
}
    `;

/**
 * __useMe__
 *
 * To run a query within a React component, call `useMe` and pass it any options that fit your needs.
 * When your component renders, `useMe` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMe({
 *   variables: {
 *   },
 * });
 */
export function useMe(baseOptions?: Apollo.QueryHookOptions<Me, MeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Me, MeVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Me, MeVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Me, MeVariables>(MeDocument, options);
        }
// @ts-ignore
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<Me, MeVariables>): Apollo.UseSuspenseQueryResult<Me, MeVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Me, MeVariables>): Apollo.UseSuspenseQueryResult<Me | undefined, MeVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<Me, MeVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<Me, MeVariables>(MeDocument, options);
        }
export type MeHookResult = ReturnType<typeof useMe>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<Me, MeVariables>;